// import React, { Component, useState } from "react";
// import { Link  } from 'react-router-dom';
// import Pagination from "react-js-pagination";
// import {GetData,PostData} from '../../services/PostData';
// import Loader from 'react-loader-spinner';
// import AddTeam from './AddTeam';
// import EditTeam from './EditTeam';
// import ListTeam from './ListTeam';
// import ReactTable from "react-table";
// import "react-table/react-table.css";
// import './team-list-css.css'
// import {apiConfig} from "../../config/api";
// import Axios from "axios";
// // import {SnackbarContent } from '@mui/material';

// // import ProjectList from '../project/ProjectList';
// // import AddProject from '../project/CreateProject';
// // import TimeLog from './TimeLogs';

// class Teamlist extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             orgdata: '',
//             teamList: [],
//             originalTeamList: [],
//             loading: false,
//             isSelectedMessage:'',
//             displaytype:'teamlist',
//             userid:'',
//             // open: false,
//             // vertical: 'top',
//             // horizontal: 'right',
//         };
//     }
//     componentDidMount() {
//         this.loadProductionTeamData();
//     }
//     loadProductionTeamData(){
//         this.setState({ loading: true});
//         GetData('get/all/team-member').then((result) => {     
//             //let remainingcredits = result.data.credits-result.data.used_credit        
//             console.log("result", result.userList);
//             this.setState({ 
//                  loading: false,
//                  teamList: result.userList,
//              });
//          });
//     }
//     // callProductionteamdata(e){        
//     //     var elem = this;
//     //     elem.loadProductionTeamData();
//     //     elem.setState({ displaytype: 'viewteam' });
//     // }
//     changeView(displaytype,userid){
//         this.setState({ displaytype: displaytype,userid:userid }); 
//         this.loadProductionTeamData();
//     }



//     handleEditUser (event, userData) {
//         console.log("---------userData", userData)
//         this.setState({
//             displaytype: "editteam",
//             userid: userData.ID
//         })

//     }
    
//     handleDeleteUser (event, userData) {
        
//         let session_key = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data.token;

//         Axios.delete(apiConfig.WEB_SERVICE_URL+`delete/team-member/${userData._id}`, {headers: {
//             'session-key': session_key, 
//             'Content-Type': 'application/json',      
//         }})
//         .then(response => {
//         //   this.setState({ open: true });
//           this.loadProductionTeamData();
//         })
//         .catch(error => {
//           console.error('There was an error!', error);
//         });
//         // this.state.setState({
//         //     displaytype: "editteam"
//         // })
//     }

//     handleClose = () => {
//         this.setState({ open: false });
//     };



//     render() {   

//         const { vertical, horizontal, open } = this.state;

//         let teamListdata=[];    
//         const loading = this.state.loading;
//         let orgdata=this.state.orgdata;
//         let orglogo='';
//         if(orgdata.orglogo)
//             orglogo=orgdata.orglogo;
//         else
//         orglogo='';
//             teamListdata=this.state.teamList;
//         let imagesrc='';
//         //console.log('orglogo====',orglogo,orgdata.orglogo,orgdata);
//         if(orglogo && orglogo!='""') {
//             //console.log('orglogo hereeeee====',orglogo);
//             try{
//                 imagesrc=require('../../assets/images/organization-logo/'+orglogo);
//                // console.log('orglogo tryyyyy====');
//             } catch {
//                // console.log('orglogo catchhhh====');
//                 imagesrc='';
//             }
//         } else {
//             imagesrc='';
//         }
//         //console.log('imagesrc====',imagesrc);
//         let { handleClick } = this.props;
//        // console.log('handleClick====',handleClick);
       

//        const teamUserList = this.state.teamList;

// 		const teamListColumns = [
//             {
//                 Header: 'Object ID',
//                 accessor: '_id',
//                 show:false,
//             },
//             {
//                 Header: 'ID',
//                 accessor: 'ID',
//                 show:false,
//             },
// 			{
//                 Header: 'Profile image',
//                 accessor: 'profile_image',
//                 show:true,
//                 Cell: ({ row }) => {
//                     const [imageError, setImageError] = useState(false);

//                     const handleImageError = () => {
//                         setImageError(true);
//                     };
//                     return (
//                         <div style={{textAlign: 'center'}}>
//                             <img 
//                                 style={{width: "50px", height: "auto", borderRadius: "50%"}} 
//                                 className="table-icon-single" 
//                                 src={`/profile-image/${row.profile_image}`}
//                                 alt="image not available"
//                             />
//                             </div>
//                     )
//                 }
//             },
// 			{
//                 Header: 'Name',
//                 accessor: 'first_name',
//                 show:true,
//                 Cell: ({ row }) => {
//                     let first_name = row.first_name; 
//                     let last_name = row.last_name; 
//                     return (
//                         <div style={{textAlign: 'center'}}><span className="childlist1">{`${first_name} ${last_name}`}</span></div>
//                     )
//                 }
//             },
//             {
//                 Header: 'Last name',
//                 accessor: 'last_name',
//                 show:false,
//             },
//             {
//                 Header: 'Email',
//                 accessor: 'email',
//                 show:true,
//                 className: 'center-text'
//             },
//             {
//                 Header: 'Phone',
//                 accessor: 'phone',
//                 show:true,
//                 Cell: ({ row }) => {
//                     let phone;
//                     if(row.phone){
//                         phone = row.phone
//                     } else {
//                         phone =" - "
//                     }

//                     return (
//                         <div style={{textAlign: 'center'}}><span className="childlist1">{phone}</span></div>
//                     )
//                 }
//             },
//             {
//                 Header: 'Status',
//                 accessor: 'status',
//                 show:true,
//                 className: 'center-text'
//             },
//             {
//                 Header: 'Action',
//                 accessor: '',
//                 show:true,
//                 filterable: false,
//                 Cell: ({ row }) => {
                    
//                     return (
//                         <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-evenly' }}>
//                             <div style={{ marginRight: '10px' }} onClick={(e)=>{this.handleEditUser(this, row)}}>
//                                 <img src={require('../../assets/images/edit-icon.png')} className="editbtn"/> 
//                             </div>
//                             {/* <div onClick={(e) => { if (window.confirm('All its related data will be deleted. Are you sure you want to delete?')) this.handleDeleteUser(this, row) } }> */}
//                             {/* <div onClick={(e) => { if (window.confirm('Are you sure you want to delete?')) this.handleDeleteUser(this, row) } }>
//                                 <img src={require('../../assets/images/delete-icon.png')} className="deletebtn"/> 
//                             </div> */}
//                         </div>
//                     );
//                 }
//             },
// 		];

       
// 		return (
// 			 <div className="container-fluid ProAssetsList"  ref="selfdiv">
//                  {
// 	        		loading ?
// 			         	<div className="loaderspinner">
// 				         	<Loader
// 						         type="TailSpin"
// 						         color="#D10000"
// 						         height={100}
// 						         width={100}						         
// 						    />
// 					    </div>
// 				 	:null 
// 			 	} 
//                 <div className="panel panel-primary">
//                     <div className="team-heading">
//                         <div className="heading">
//                             Team management
//                         </div>
//                     </div>
                    
//                     {/* <SnackbarContent 
//                         anchorOrigin={{ vertical, horizontal }}
//                         open={open}
//                         onClose={this.handleClose}
//                         message="User deleted successfully"
//                         key={vertical + horizontal}
//                     /> */}

//                     { this.state.displaytype==='teamlist' &&
//                         <>
//                             <div className="TeamWrapBarTop panel-heading" >
//                                 <div className="create_user btn btn-info" onClick={(e)=>{this.changeView('addteam')}}>Create User</div>
//                             </div>
//                             <div>
//                                 {teamUserList && teamUserList.length>0 &&
//                                     <ReactTable
//                                         data={teamUserList} 
//                                         showPagination= {true}
//                                         showPaginationTop = {false}
//                                         showPaginationBottom = {true}
//                                         showPageSizeOptions = {true}                      
//                                         pageSizeOptions = {[5, 10, 20, 25, 50, 100]}                      
//                                         minRows = {10}
//                                         defaultPageSize={10}
//                                         filterable={true}
//                                         // pageSizeOptions = {[10,50,100]}
//                                         // defaultPageSize = {10}                         
//                                         columns={teamListColumns}
//                                         // getTrProps={this.getTrProps}
//                                         className="-striped -highlight table table-striped ListTable assetlist"
//                                     />
//                                 }
//                             </div>
//                         </>
//                     }
                    
//                     {/* {    
//                         (this.state.displaytype==='viewteam' &&
//                             <div className="team-list">  
//                                 <ListTeam view={this.changeView.bind(this)} teamlist={this.state.teamList} orgiteamlist={this.state.originalTeamList} orgid={this.props.match.params.orgid} /> 
//                             </div>
//                         )
//                     } */}
//                     {   
//                         (this.state.displaytype==='addteam' &&
//                             <div className="add-team">
//                                 <AddTeam  view={this.changeView.bind(this)} userid={this.state.userid} />
//                             </div> 
//                         )
//                     } 
//                     {   
//                         (this.state.displaytype==='editteam' &&
//                             <div className="add-team">
//                                 <EditTeam view={this.changeView.bind(this)} userid={this.state.userid} />
//                             </div> 
//                         )
//                     }
//                 </div>
//             </div>
// 		);
//     }
// }
// export default Teamlist;






import React, { Component } from "react";
import { Link  } from 'react-router-dom';
import Pagination from "react-js-pagination";
import {GetData,PostData} from '../../services/PostData';
import Loader from 'react-loader-spinner'
import AddTeam from './AddTeam'
import EditTeam from './EditTeam'
import ListTeam from './ListTeam'
import ReactTable from "react-table";
import "react-table/react-table.css";
import './team-list-css.css'
import { MdSearch } from "react-icons/md";
// import ProjectList from '../project/ProjectList';
// import AddProject from '../project/CreateProject';
// import TimeLog from './TimeLogs';

class Teamlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgdata: '',
            teamList: [],
            originalTeamList: [],
            loading: false,
            isSelectedMessage:'',
            displaytype:'teamlist',
            userid:'',
            activePage: 1,
			itemPerPage:6,
            searchText: '',
            isdiagram:true,
            isMax:false,
            selectedStatusValue: '',
        };
        this.projectDetails = this.projectDetails.bind(this);
        // this.deleteProject = this.deleteProject.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.searchValue = this.searchValue.bind(this);
        this.setSize=this.setSize.bind(this);
    }
    componentDidMount() {
        this.loadProductionTeamData();
    }
    loadProductionTeamData(){
        this.setState({ loading: true});
        GetData('get/all/team-member').then((result) => {     
            //let remainingcredits = result.data.credits-result.data.used_credit        
            console.log("result", result.userList);
            this.setState({ 
                loading: false,
                teamList: result.userList,
                teamList: result.userList,
                originalTeamList: result.userList
             });
         });
    }
    // callProductionteamdata(e){        
    //     var elem = this;
    //     elem.loadProductionTeamData();
    //     elem.setState({ displaytype: 'viewteam' });
    // }
    changeView(displaytype,userid){
        this.setState({ displaytype: displaytype,userid:userid }); 
        this.loadProductionTeamData();
    }


    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        console.log(this.state.teamList);
    }

    projectDetails(item, index) {
        console.log(index);
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    setSize(){
        this.setState({
            isMax:!this.state.isMax
        });             
        if(!this.state.isMax){
        }
        console.log(this.props.children);
        if(this.props.children[1].props['data-event']){
            var self=this;
            setTimeout(()=>{
                self.props.children[1].props['data-event'].call();  
            },700);         
        }
    }

    searchValue(event){
        this.setState({
            searchText: event.target.value
        })
    }

    updateInputValue(event) {
        // this.setState({
        //     searchText: event.target.value
        // }, function () {
        // });
        let textToSearch = this.state.searchText.toLowerCase();
        if (textToSearch != undefined || textToSearch != '') {
            let searchData = [];
            for (var i = 0; i < this.state.originalTeamList.length; i++) {
                let name=`${this.state.originalTeamList[i].first_name} ${this.state.originalTeamList[i].last_name}`;
                name = name.toLowerCase();
                if(name!=null) {
                    if (name.indexOf(textToSearch) != -1) {
                        searchData.push(this.state.originalTeamList[i]);
                    }
                }
            }
            this.setState({
                teamList: searchData
            });
        }

        if(textToSearch == '') {
            this.setState({
                teamList: this.state.originalTeamList, 
            });
        }
    }

    handleEditUser(event, userData) {
        this.setState({
            displaytype: "editteam",
            userid: userData.ID
        })
    }

    handleStatusChange (e) {
        this.setState({
            selectedStatusValue: e.target.value
        })

        let textToSearch = e.target.value;
        if (textToSearch != undefined || textToSearch != '') {
            let searchData = [];
            for (var i = 0; i < this.state.originalTeamList.length; i++) {
                let status=`${this.state.originalTeamList[i].status}`;
                if(status != null) {
                    if(e.target.value == 'all'){
                        textToSearch = ''
                        break;
                    } else {
                        if (status == e.target.value) {
                            searchData.push(this.state.originalTeamList[i]);
                        }
                    }
                }
            }
            this.setState({
                teamList: searchData,
                activePage: 1
            });
        }

        if(textToSearch == '') {
            this.setState({
                teamList: this.state.originalTeamList, 
            });
        }
    }


    render() {   
        let teamListdata=[];    
        const loading = this.state.loading;
        let orgdata=this.state.orgdata;
        let orglogo='';
        if(orgdata.orglogo)
            orglogo=orgdata.orglogo;
        else
            orglogo='';
        
        teamListdata=this.state.teamList;
        let imagesrc='';
        //console.log('orglogo====',orglogo,orgdata.orglogo,orgdata);

        if (orglogo && orglogo != '""') {
            //console.log('orglogo hereeeee====',orglogo);
            try {
                imagesrc = require('../../assets/images/organization-logo/' + orglogo);
                // console.log('orglogo tryyyyy====');
            } catch {
                // console.log('orglogo catchhhh====');
                imagesrc = '';
            }
        } else {
            imagesrc = '';
        }

        let projectlink = '';
        let indexOfLastTodo = this.state.activePage * this.state.itemPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.itemPerPage;
        let renderedProjects = this.state.teamList.slice(indexOfFirstTodo, indexOfLastTodo);
        
        let listItems = renderedProjects.map((item, index) => {
            
            let image;
            let noImage = 'no_image.png';
            try {
                image = require(`../../../public/profile-image/${item.profile_image}`);
            } catch (error) {
                image = require(`../../../public/profile-image/${noImage}`);
            }

            return <tr key={index}>
                <td className="tbl_org_duedate">
                    <img className="table-profile-image" alt="image not available" src={image} onError={this.state.noImageSrc}/>
                </td>
                <td className="tbl_org_name">
                    <Link to={projectlink}><u>{`${item.first_name} ${item.last_name}`}</u></Link>
                </td>
                <td className="tbl_org_duedate">{item.email}</td>
                <td className="tbl_org_duedate">{item.phone}</td>
                <td className="tbl_org_duedate">{item.status}</td>
                <td className="tbl_org_action TblIconDel">
                    <div style={{ marginRight: '10px' }} onClick={(e)=>{this.handleEditUser(this, item)}}>
                        <img src={require('../../assets/images/edit-icon.png')} className="editbtn"/> 
                    </div>
                </td>
            </tr>
        });
        

        return (
            <div className="container-fluid ProjectList"  ref="selfdiv">
                <div className="team-heading">
                    <div className="heading">
                        Team management
                    </div>
                </div>
                {
                    (this.state.displaytype === 'teamlist' && <div className="panel panel-primary table-panel">
                        <div className="WrapBarTop panel-heading">
                            <div className="search-header">
                                <div className="col-md-3 col-lg-3">
                                    <div style={{ display: 'flex' }}>
                                        <input type="text" className="form-control search-type" placeholder="Search" value={this.state.searchText} onChange={this.searchValue} />
                                        <div className="search-icon" onClick={this.updateInputValue}>
                                            <MdSearch color='#fff' fontWeight={800} fontSize='large' />
                                        </div>
                                    </div>
                                </div>
                                <div className="TeamWrapBarTop panel-heading create-user-btn" >
                                    <div className="select-main-div">
                                        <select id="options" value={this.state.selectedStatusValue} onChange={this.handleStatusChange}>
                                            <option value="all">All</option>
                                            <option value="active">active</option>
                                            <option value="inactive">inactive</option>
                                        </select>
                                    </div>
                                    <div className="create_user btn btn-info" onClick={(e) => { this.changeView('addteam') }}>Create User</div>
                                </div>
                            </div>
                        </div>
                        <div className="panel-body">
                            {/* <Link to={productionteamlink} className="production-team">Production Team</Link>  */}
                            <table className="table table-striped ListTable">
                                <thead>
                                    <tr>
                                        <th><b>profile image</b></th>
                                        <th><b>Name</b></th>
                                        <th><b>Email</b></th>
                                        <th><b>Phone</b></th>
                                        <th><b>Status</b></th>
                                        <th style={{ paddingRight: '30px' }}><b>Action</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listItems}
                                </tbody>
                            </table>
                        </div>
                        <div className="Mobrow">
                            <div className="pagination-div">
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={6}
                                    totalItemsCount={this.state.teamList.length}
                                    pageRangeDisplayed={20}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                        </div>
                    </div>)
                }
                {
                    (this.state.displaytype === 'addteam' &&
                        <div className="add-team add-team-div">
                            <AddTeam view={this.changeView.bind(this)} userid={this.state.userid} />
                        </div>
                    )
                }
                {
                    (this.state.displaytype === 'editteam' &&
                        <div className="add-team add-team-div">
                            <EditTeam view={this.changeView.bind(this)} userid={this.state.userid} />
                        </div>
                    )
                }
            </div>
       );


		// return (
		// 	 <div className="container-fluid ProAssetsList"  ref="selfdiv">
        //          {
	    //     		loading ?
		// 	         	<div className="loaderspinner">
		// 		         	<Loader
		// 				         type="TailSpin"
		// 				         color="#D10000"
		// 				         height={100}
		// 				         width={100}						         
		// 				    />
		// 			    </div>
		// 		 	:null 
		// 	 	} 
        //         <div className="panel panel-primary">

        //             <div>
        //                 {teamUserList && teamUserList.length>0 &&
        //                     <ReactTable
        //                         data={teamUserList} 
        //                         showPagination= {true}
        //                         showPaginationTop = {false}
        //                         showPaginationBottom = {true}
        //                         showPageSizeOptions = {true}                      
        //                         pageSizeOptions = {[5, 10, 20, 25, 50, 100]}                      
        //                         minRows = {10}
        //                         defaultPageSize={10}
        //                         filterable={true}
        //                         // pageSizeOptions = {[10,50,100]}
        //                         // defaultPageSize = {10}                         
        //                         columns={teamListColumns}
        //                         // getTrProps={this.getTrProps}
        //                         className="-striped -highlight table table-striped ListTable assetlist"
        //                     />
        //                 }
        //             </div>
                    
        //             {    
        //                 (this.state.displaytype==='viewteam' &&
        //                     <div className="team-list">  
        //                         <ListTeam view={this.changeView.bind(this)} teamlist={this.state.teamList} orgiteamlist={this.state.originalTeamList} orgid={this.props.match.params.orgid} /> 
        //                     </div>
        //                 )
        //             }
        //             {   
        //                 (this.state.displaytype==='addteam' &&
        //                     <div className="add-team">
        //                         <AddTeam orgname={this.state.orgdata.organization_name} view={this.callProductionteamdata.bind(this)} orgid={this.props.match.params.orgid} />
        //                     </div> 
        //                 )
        //             } 
        //             {   
        //                 (this.state.displaytype==='editteam' &&
        //                     <div className="add-team">
        //                         <EditTeam view={this.changeView.bind(this)} userid={this.state.userid} orgid={this.props.match.params.orgid} />
        //                     </div> 
        //                 )
        //             }
        //         </div>
        //     </div>
		// );
    }
}
export default Teamlist;
